module.exports = __webpack_public_path__ + "img/test.b5cbc482.jpg";